import { normalizeSrc } from '@/app/components/media/app-image/shared/image-source';
import { type ImageKitParams } from '@/app/components/media/app-image/shared/imagekit-types';
import { mergeQuery } from '@/app/components/media/app-image/shared/url-query';
import { isPng } from '@/app/utils/image';

const getContentstackCrop = (aspectRatio: ImageKitParams['ar']) => {
  if (typeof aspectRatio !== 'string') return undefined;

  const match = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/.exec(aspectRatio);
  return match ? `${match[1]}:${match[2]}` : undefined;
};

const getContentstackAutoFormat = (format: ImageKitParams['f']) =>
  format === 'avif' || format === 'webp' ? format : 'webp';

export const buildContentstackUrl = (
  srcInput: unknown,
  params?: ImageKitParams
): string => {
  const src = normalizeSrc(srcInput);
  if (!src) return '';

  const quality = typeof params?.q === 'number' ? params.q : 75;
  const width = typeof params?.w === 'number' ? params.w : undefined;
  const height = typeof params?.h === 'number' ? params.h : undefined;
  const crop = getContentstackCrop(params?.ar);
  const autoFormat = getContentstackAutoFormat(params?.f);

  const patch: Record<string, unknown> = {
    format: isPng(src) ? 'png' : 'pjpg',
    auto: autoFormat,
    quality: String(quality),
  };
  if (width && width > 0) patch.width = String(width);
  if (height && height > 0) patch.height = String(height);
  if (crop) patch.crop = crop;

  return mergeQuery(src, patch);
};
